export { parseWSMessage } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';

// Possible message types
export const ALERT = 'alert';
export const ALERT_LOG_MESSAGE = 'alert_log_message';
export const DATA = 'data';
export const EVENT_RECEIVE = 'event_receive';
export const EVENT_SHARE = 'event_share';
export const LOCATION = 'location';
export const PARTICIPANT_ADDED = 'participant_added';
export const SPATIAL = 'spatial';
export const SUBSCRIPTION = 'subscription';
export const LOCATION_UPDATE_TEXT = 'location_update.text';
